/**
 * @author Ariel
 * @description 经销商管理
 * @Date 2020/1/10
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool,framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate,modelUtils} = framework_tool;
let {WizBrowserExport} = component_tool
import moment from "moment";
import { element } from "prop-types";

class DealerAppealManager extends WizContainer {
  componentName = 'dealerAppealManager';

  constructor(props) {
    super(props);
    this.state={
      dataInfo:[]
    }
  }

  _componentDidMount() {
    this._getVehicleModelList();
  }

  propsAndStateOnChange = {
    vehicleModelList: this._vehicleModelList.bind(this),
  }

  _vehicleModelList(nextProps, nextState) {
    let { vehicleModelList } = nextProps
    if (vehicleModelList['success']) {
      nextState['dataInfo'] = vehicleModelList['data']
      return true;
    } else {
      wizNotice.error(vehicleModelList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _getVehicleModelList(apiParams = {}) {
    this.doAction({
      path: 'dealerAppeal/getVehicleModelList',
      payload: {
        key: 'dealerAppeal@vehicleModelList',
        apiParams: {
          ...apiParams
        }
      }
    })
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '品牌',
        field: 'brandName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '区域',
        field: 'areaName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '门店代码',
        field: 'dealerCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '门店名称',
        field: 'dealerName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发出者',
        field: 'sender',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发出者手机号',
        field: 'senderMobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发出者邮箱',
        field: 'senderMail',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发出日期',
        field: 'senderTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '车型',
        field: 'vehicleModelName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '车架号',
        field: 'vehicleIdentifyNum',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发票金额(元)',
        field: 'invoiceValue',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发票日期',
        field: 'invoiceTime',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'mail',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否置换',
        field: 'isDisplace',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '置换类型',
        field: 'displaceType',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否增购',
        field: 'isAdd',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '增购类型',
        field: 'addType',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否按揭',
        field: 'isMortgage',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '按揭金额(元)',
        field: 'mortgageValue',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '情况说明',
        field: 'explanation',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否质损车',
        field: 'isDamaged',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否试乘试驾车',
        field: 'isTestDrive',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否集团客户',
        field: 'isBloc',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否享受政府补贴',
        field: 'isSubsidy',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '政策名称',
        field: 'subsidyInfo',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '补贴金额(元)',
        field: 'subsidyValue',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '补贴申领方式',
        field: 'subsidyWay',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否VIP购车',
        field: 'isVip',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否高库龄',
        field: 'isAging',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否可再次提交',
        field: 'isAllowSubmit',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '第几次提交',
        field: 'submitNum',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发票附件',
        field: 'invoiceImgsUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '置换附件',
        field: 'displaceImgsUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '贷款附件',
        field: 'mortgageImgsUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '其他附件',
        field: 'otherImgsUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '质损视频附件',
        field: 'videosUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      
      {
        headerName: '质损附件',
        field: 'damagedFilesUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '试驾附件',
        field: 'testDriveFilesUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '集团客户附件',
        field: 'blocFilesUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '补贴附件',
        field: 'subsidyFilesUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: 'VIP附件',
        field: 'vipFilesUrl',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]

    // let dict = [
    //   { code: 1, codeName: 'GL8 ES 653T 舒适型 23' },
    //   { code: 2, codeName: 'GL8 ES 653T 尊享型 23' },
    //   { code: 3, codeName: 'GL8 ES 653T 豪华型(谦和米) 23' },

    //   { code: 4, codeName: 'GL8 陆尊插混 智享版 25.5' },
    //   { code: 5, codeName: 'GL8 陆尊插混 尊享版 25.5' },
    //   { code: 6, codeName: 'GL8 陆尊插混 七座奢享版(玄武月白内饰) 25.5' },
    //   { code: 7, codeName: 'GL8 陆尊插混 七座奢享版(黛蓝月白内饰) 25.5' },
    //   { code: 8, codeName: 'GL8 陆尊插混 六座奢享版(黛蓝月白内饰) 25.5' },

    //   { code: 9, codeName: 'GL8 Avenir艾维亚 六座贤礼版(Sangria) 23' },

    //   { code: 10, codeName: 'GL8 652T 舒适型 24' },
    //   { code: 11, codeName: 'GL8 652T 智享型 24' },
    //   { code: 12, codeName: 'GL8 652T 豪华型(谦和米) 24' },
    //   { code: 13, codeName: 'GL8 652T 尊贵型(谦和米) 24' },
    //   { code: 14, codeName: 'GL8 652T 智慧尊贵型 24' },
    //   { code: 15, codeName: 'GL8 豪华型-专供版 24' },
    //   { code: 16, codeName: 'GL8 智享型-专供版 24' },

    //   { code: 17, codeName: '昂科威Plus 28T 豪华型 24' },
    //   { code: 18, codeName: '昂科威Plus 28T 尊享版(页岩黑) 24' },
    //   { code: 19, codeName: '昂科威Plus 28T 尊享版(丹霞红) 24' },
    //   { code: 20, codeName: '昂科威Plus 28T 四驱尊享版 24' },
    //   { code: 21, codeName: '昂科威Plus 艾维亚 24.5' },

    //   { code: 22, codeName: '世纪CENTURY 七座臻享款 23' },
    //   { code: 23, codeName: '世纪CENTURY 七座蕴世版(红黑内饰-赤霞红座椅) 23' },
    //   { code: 24, codeName: '世纪CENTURY 七座蕴世版(蓝白内饰-云峰白座椅) 23' },
    //   { code: 25, codeName: '世纪CENTURY 六座蕴世版(红黑内饰-赤霞红座椅) 23' },
    //   { code: 26, codeName: '世纪CENTURY 六座蕴世版(蓝白内饰-云峰白座椅) 23' },
    //   { code: 27, codeName: '世纪CENTURY 四座私享版(青白内饰-冷杉青座椅) 23' },
    //   { code: 28, codeName: '世纪CENTURY 四座私享版(青白内饰-云峰白座椅) 23' },
    //   { code: 29, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-冷杉青座椅) 23' },
    //   { code: 30, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-云峰白座椅) 23' }
    // ]

    let dictAddType = [
      { code: 1, codeName: '奔驰' },
      { code: 2, codeName: '宝马' },
      { code: 3, codeName: '奥迪' },
      { code: 4, codeName: '凯迪拉克' },
      { code: 5, codeName: '雪佛兰' },
      { code: 6, codeName: '别克' }
    ]

    if (o['success']) {
      let data = o['data']
      let urlKeys = ['invoiceImgsUrl','displaceImgsUrl','mortgageImgsUrl','otherImgsUrl','videosUrl',
        'damagedFilesUrl','testDriveFilesUrl','blocFilesUrl','subsidyFilesUrl','vipFilesUrl']
      data && data.forEach(e => {
        e.isDisplace == 0 ? e.isDisplace = '否' : e.isDisplace = '是'
        e.displaceType == 1 ? e.displaceType = '本品置换' : e.displaceType == 2 ? e.displaceType ='竞品置换':''
        e.isAdd == 0 ? e.isAdd = '否' : e.isAdd ='是'
        e.invoiceTime = e.invoiceTime ? moment(e.invoiceTime).format('YYYY-MM-DD') : '';
        e.isMortgage == 0 ? e.isMortgage = '否' : e.isMortgage ='是'

         e.isDamaged == 0 ? e.isDamaged = '否' : e.isDamaged = '是'
         e.isTestDrive == 0 ? e.isTestDrive = '否' : e.isTestDrive = '是'
         e.isBloc == 0 ? e.isBloc = '否' : e.isBloc = '是'
         e.isSubsidy == 0 ? e.isSubsidy = '否' : e.isSubsidy = '是'
         e.isVip == 0 ? e.isVip = '否' : e.isVip = '是'
         e.isAging == 0 ? e.isAging = '否' : e.isAging = '是' 
         e.subsidyWay == 1 ? e.subsidyWay = '个人' : e.subsidyWay == 2 ? e.subsidyWay ='经销商代办':''
         e.isAllowSubmit == 0 ? e.isAllowSubmit='否': e.isAllowSubmit='是'
        // dict.forEach(element=>{
        //   if(e.vehicleModelId==element.code){
        //     e.vehicleModelId = element.codeName
        //   }
        // })

        dictAddType.forEach(element=>{
          if(e.addType==element.code){
            e.addType = element.codeName
          }
        })

        for(let key in e){
          if(urlKeys.includes(key)){
            if(e[key] && e[key].indexOf(';')!==-1){
              let imgsUrl = e[key].split(";");
              let imgsUrlShow = undefined;
              imgsUrl.forEach(element=>{
                if(imgsUrlShow){
                  imgsUrlShow+='\n'+element
                }else{
                  imgsUrlShow = element
                }
              })
              e[key] = imgsUrlShow
            }else if(e[key]){
              e[key]= {
                text:e[key],
                hyperlink:e[key]
              }
            }
          }
        }

      })
      WizBrowserExport({
        title: '健康度材料回收',
        sheetName: '健康度材料回收',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '健康度材料回收.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig(this.state.dataInfo),
      apiDataFormat: {
        delete: this._handleCMD,
        export: this._handleFile
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  let { dealerAppeal } = state
  const vehicleModelList = modelUtils.getModelEntity(dealerAppeal, 'dealerAppeal@vehicleModelList');
  const load = modelUtils.getLoadingState(state, 'dealerAppeal')
  return {
    vehicleModelList,
    ...load
  }
};

export default connect(mapStateToProps)(DealerAppealManager);
